// extracted by mini-css-extract-plugin
export default {"csrTextArea":"CSROption-csrTextArea_kXfUI"};